export enum FeatureFlagEnum {
  branded_packaging = 'branded_packaging',
  e_store_onboarding_flow = 'e_store_onboarding_flow',
  destygo_webchat = 'destygo_webchat',
  gelato_plus_upsell = 'gelato_plus_upsell',
  onboarding_subscription_modal = 'onboarding_subscription_modal',
  mockup_studio = 'mockup_studio',
  editor_image_edit_tab = 'editor_image_edit_tab',
  is_gold_trial_not_available = 'is_gold_trial_not_available',
  subscription_activation_widget = 'subscription_activation_widget',
  framed_posters_upgrade = 'framed_posters_upgrade',
  price_navigator = 'price_navigator',
  price_navigator_strategies = 'price_navigator_strategies',
  etsy_connection_issue_warning = 'etsy_connection_issue_warning',
  image_enhancement = 'image_enhancement',
  iphone_14 = 'iphone_14',
  image_upscaling = 'image_upscaling',
  enable_mockup_leaning = 'enable_mockup_leaning',
  apparel_dynamic_mockups = 'apparel_dynamic_mockups',
  e_comm_new_pricing_table = 'e_comm_new_pricing_table',
  amazon_integration = 'amazon_integration',
  branded_packaging_production_countries = 'branded_packaging_production_countries',
  bank_transfer = 'bank_transfer',
  embroidery = 'embroidery',
  embroidery_publisher = 'embroidery_publisher',
  interactive_translation = 'interactive_translation',
  product_expansion_fit_fill_toggle = 'product_expansion_fit_fill_toggle',
  enable_levity_image_validation = 'enable_levity_image_validation',
  ai_personalization_for_etsy = 'ai_personalization_for_etsy',
  is_shopify_personalization_enabled = 'is_shopify_personalization_enabled',
  etsy_orders_import = 'etsy_orders_import',
  personalisation_page = 'personalisation_page',
}
